import type { EmployerInfoUpsertPayload } from '~/features/employer/components';
import type { EmployerInfo } from '~/types/hlx/employerInfo';
import { getData, putData } from '~/utils/service';

export const getCurrentEmployerInfo = async (): Promise<EmployerInfo | null> => {
  return await getData('employerInfo');
};

export const upsertCurrentEmployerInfo = async (
  data: EmployerInfoUpsertPayload
): Promise<EmployerInfo> => {
  return await putData('employerInfo', {
    data,
  });
};
